var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Hzhb-container"},[_c('div',{staticClass:"Hzhb-title"},[_vm._v("合作伙伴")]),_c('div',{staticClass:"Hzhb-img-List"})])
}]

export { render, staticRenderFns }